var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#393939;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-304 -56)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(304 56)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(306 59)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.85,0H0L6.74,7.97v5.51l3.37,1.685V7.97L16.85,0Z",
    transform: "translate(1.575 1.418)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.5a048ec2.svg";
export { ForwardRef as ReactComponent };